var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 48,
    viewBox: "0 0 153 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 48,
    rx: 6,
    fill: "#F7FAFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7311 12.8228C53.7311 13.7455 53.4592 14.4815 52.9154 15.0198C52.3063 15.6679 51.5015 15.9975 50.5227 15.9975C49.5764 15.9975 48.7825 15.6679 48.119 15.0088C47.4556 14.3497 47.1293 13.5258 47.1293 12.5592C47.1293 11.5815 47.4556 10.7686 48.119 10.1095C48.7825 9.4504 49.5764 9.12085 50.5227 9.12085C50.9903 9.12085 51.4363 9.20873 51.8604 9.39547C52.2846 9.58222 52.6218 9.82389 52.8828 10.1315L52.3063 10.7137C51.8713 10.1974 51.284 9.93374 50.5227 9.93374C49.8375 9.93374 49.2393 10.1754 48.739 10.6697C48.2387 11.1531 47.9885 11.7902 47.9885 12.5701C47.9885 13.3501 48.2387 13.9872 48.739 14.4705C49.2393 14.9539 49.8375 15.2065 50.5227 15.2065C51.2514 15.2065 51.8604 14.9649 52.3499 14.4705C52.6653 14.152 52.8502 13.7016 52.8937 13.1304H50.5227V12.3175H53.6876C53.7094 12.4932 53.7311 12.658 53.7311 12.8228Z",
    fill: "#333D4D",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.745 10.0656H55.7758V12.1527H58.4513V12.9436H55.7758V15.0308H58.745V15.8437H54.9384V9.25269H58.745V10.0656Z",
    fill: "#333D4D",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2798 15.8437H61.4423V10.0656H59.6151V9.25269H64.0961V10.0656H62.2689V15.8437H62.2798Z",
    fill: "#333D4D",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.348 15.8437V9.25269H68.1855V15.8437H67.348Z",
    fill: "#333D4D",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9051 15.8437H71.0677V10.0656H69.2405V9.25269H73.7214V10.0656H71.8943V15.8437H71.9051Z",
    fill: "#333D4D",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2157 14.9978C81.574 15.6679 80.7801 15.9975 79.823 15.9975C78.8659 15.9975 78.0719 15.6679 77.4302 14.9978C76.7885 14.3277 76.4731 13.5148 76.4731 12.5592C76.4731 11.6035 76.7885 10.7796 77.4302 10.1205C78.0719 9.4504 78.8659 9.12085 79.823 9.12085C80.7692 9.12085 81.5631 9.4504 82.2157 10.1205C82.8574 10.7906 83.1837 11.6035 83.1837 12.5592C83.1728 13.5148 82.8574 14.3277 82.2157 14.9978ZM78.0502 14.4486C78.5287 14.9429 79.1269 15.1846 79.823 15.1846C80.519 15.1846 81.1172 14.9429 81.5958 14.4486C82.0743 13.9542 82.3245 13.3281 82.3245 12.5592C82.3245 11.7902 82.0852 11.1641 81.5958 10.6697C81.1172 10.1754 80.519 9.93374 79.823 9.93374C79.1269 9.93374 78.5287 10.1754 78.0502 10.6697C77.5716 11.1641 77.3215 11.7902 77.3215 12.5592C77.3215 13.3281 77.5607 13.9542 78.0502 14.4486Z",
    fill: "#333D4D",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3474 15.8437V9.25269H85.3698L88.5456 14.3827H88.5783L88.5456 13.1084V9.25269H89.3831V15.8437H88.513L85.1958 10.472H85.1632L85.1958 11.7463V15.8547H84.3474V15.8437Z",
    fill: "#333D4D",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2556 25.4664C73.6997 25.4664 71.6115 27.4327 71.6115 30.135C71.6115 32.8264 73.6997 34.8036 76.2556 34.8036C78.8115 34.8036 80.8997 32.8264 80.8997 30.135C80.8997 27.4217 78.8224 25.4664 76.2556 25.4664ZM76.2556 32.9692C74.8526 32.9692 73.6453 31.8047 73.6453 30.135C73.6453 28.4543 74.8526 27.3009 76.2556 27.3009C77.6586 27.3009 78.8659 28.4543 78.8659 30.135C78.8659 31.7938 77.6586 32.9692 76.2556 32.9692ZM66.1299 25.4664C63.574 25.4664 61.4858 27.4327 61.4858 30.135C61.4858 32.8264 63.574 34.8036 66.1299 34.8036C68.6858 34.8036 70.774 32.8264 70.774 30.135C70.774 27.4217 68.6858 25.4664 66.1299 25.4664ZM66.1299 32.9692C64.7269 32.9692 63.5196 31.8047 63.5196 30.135C63.5196 28.4543 64.7269 27.3009 66.1299 27.3009C67.5329 27.3009 68.7402 28.4543 68.7402 30.135C68.7402 31.7938 67.5329 32.9692 66.1299 32.9692ZM54.0792 26.8945V28.8718H58.7776C58.6363 29.9922 58.2665 30.8051 57.7118 31.3653C57.0266 32.0574 55.9607 32.8154 54.09 32.8154C51.197 32.8154 48.9347 30.4646 48.9347 27.5426C48.9347 24.6206 51.197 22.2698 54.09 22.2698C55.6453 22.2698 56.7873 22.8849 57.6248 23.6868L59.006 22.2917C57.8314 21.1603 56.2761 20.2925 54.0792 20.2925C50.1202 20.2925 46.7921 23.544 46.7921 27.5536C46.7921 31.5521 50.1202 34.8146 54.0792 34.8146C56.2218 34.8146 57.8314 34.1116 59.0931 32.7824C60.3873 31.4752 60.7897 29.6297 60.7897 28.1467C60.7897 27.6854 60.7571 27.257 60.681 26.9054H54.0792V26.8945ZM103.359 28.4324C102.978 27.3888 101.804 25.4554 99.4 25.4554C97.0181 25.4554 95.0387 27.3448 95.0387 30.124C95.0387 32.7385 96.9964 34.7927 99.6284 34.7927C101.749 34.7927 102.978 33.4855 103.479 32.7275L101.902 31.6619C101.379 32.4419 100.662 32.9582 99.6284 32.9582C98.5952 32.9582 97.8556 32.4858 97.3879 31.5411L103.576 28.9596L103.359 28.4324ZM97.0508 29.9922C96.9964 28.1907 98.432 27.2679 99.4653 27.2679C100.27 27.2679 100.955 27.6744 101.184 28.2566L97.0508 29.9922ZM92.026 34.518H94.0598V20.7868H92.026V34.518ZM88.687 26.51H88.6218C88.165 25.9607 87.2949 25.4664 86.1855 25.4664C83.8689 25.4664 81.748 27.5206 81.748 30.157C81.748 32.7714 83.8689 34.8146 86.1855 34.8146C87.284 34.8146 88.165 34.3203 88.6218 33.7491H88.687V34.4192C88.687 36.2097 87.7408 37.1654 86.2181 37.1654C84.9782 37.1654 84.206 36.2647 83.8906 35.5067L82.1178 36.2537C82.629 37.495 83.9776 39.0109 86.2181 39.0109C88.6 39.0109 90.6121 37.5938 90.6121 34.1446V25.752H88.687V26.51ZM86.3595 32.9692C84.9565 32.9692 83.7819 31.7828 83.7819 30.157C83.7819 28.5093 84.9565 27.3119 86.3595 27.3119C87.7408 27.3119 88.8284 28.5202 88.8284 30.157C88.8284 31.7828 87.7408 32.9692 86.3595 32.9692ZM112.876 20.7868H108.014V34.518H110.048V29.3221H112.886C115.138 29.3221 117.346 27.6744 117.346 25.06C117.346 22.4455 115.127 20.7868 112.876 20.7868ZM112.93 27.4108H110.048V22.6982H112.93C114.453 22.6982 115.312 23.9725 115.312 25.049C115.312 26.1145 114.453 27.4108 112.93 27.4108ZM125.47 25.4335C124.002 25.4335 122.479 26.0926 121.848 27.5316L123.654 28.2896C124.034 27.5316 124.752 27.2789 125.503 27.2789C126.547 27.2789 127.624 27.9161 127.634 29.0475V29.1903C127.265 28.9816 126.482 28.663 125.514 28.663C123.567 28.663 121.598 29.7396 121.598 31.7498C121.598 33.5843 123.186 34.7707 124.97 34.7707C126.329 34.7707 127.091 34.1555 127.558 33.4305H127.624V34.4961H129.581V29.2343C129.603 26.7956 127.798 25.4335 125.47 25.4335ZM125.231 32.9582C124.567 32.9582 123.643 32.6176 123.643 31.7938C123.643 30.7392 124.796 30.3328 125.796 30.3328C126.688 30.3328 127.112 30.5305 127.645 30.7941C127.482 32.0574 126.405 32.9582 125.231 32.9582ZM136.738 25.741L134.41 31.6949H134.345L131.931 25.741H129.744L133.366 34.0677L131.3 38.6923H133.421L139 25.741H136.738ZM118.455 34.518H120.489V20.7868H118.455V34.518Z",
    fill: "#333D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 9.84594C13.1849 10.1865 13 10.7138 13 11.3948V35.6936C13 36.3747 13.1849 36.902 13.5003 37.2315L13.5764 37.3084L27.052 23.698V23.5332V23.3685L13.5873 9.76904L13.5003 9.84594Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5547 28.2347L27.0629 23.6979V23.5331V23.3683L31.5547 18.8315L31.6526 18.8865L36.971 21.9403C38.4937 22.8081 38.4937 24.2362 36.971 25.115L31.6526 28.1688L31.5547 28.2347Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6526 28.1799L27.0628 23.5442L13.5003 37.2315C14.0006 37.7697 14.8272 37.8357 15.7625 37.2974L31.6526 28.1799Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6526 18.8975L15.7625 9.77997C14.8272 9.2417 14.0006 9.30761 13.5003 9.84588L27.052 23.5332L31.6526 18.8975Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.5547 28.0811L15.7625 37.1327C14.8816 37.638 14.0876 37.605 13.5873 37.1437L13.5003 37.2315L13.5764 37.3084C14.0876 37.7698 14.8707 37.8028 15.7517 37.2975L31.6417 28.1799L31.5547 28.0811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M13.5003 37.0667C13.1849 36.7262 13 36.2099 13 35.5288V35.6936C13 36.3747 13.1849 36.9019 13.5003 37.2315L13.5764 37.1546L13.5003 37.0667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M36.971 24.9613L31.5438 28.07L31.6417 28.1689L36.9601 25.115C37.7215 24.6756 38.1021 24.1044 38.1021 23.5332C38.0478 24.0605 37.6671 24.5658 36.971 24.9613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.7625 9.94421L36.971 22.1156C37.6562 22.511 38.0477 23.0163 38.113 23.5436C38.113 22.9724 37.7323 22.3902 36.971 21.9618L15.7625 9.77943C14.2399 8.91162 13 9.63663 13 11.3942V11.559C13 9.79042 14.2399 9.06541 15.7625 9.94421Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.8633,
    y1: 11.1356,
    x2: 7.42878,
    y2: 29.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 38.9524,
    y1: 23.5395,
    x2: 12.6356,
    y2: 23.5395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 29.1558,
    y1: 26.0602,
    x2: 4.15712,
    y2: 50.8112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.0903,
    y1: 1.76148,
    x2: 21.2534,
    y2: 12.8138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 30,
    fill: "white",
    transform: "translate(13 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.1ce4a12de81e35028fa312b498132e92.svg";
export { ForwardRef as ReactComponent };